import React, {Component} from 'react';
import css from './Blog.module.scss';
import {connect} from "react-redux";
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const Blog = class extends Component {

    source = axios.CancelToken.source();
    
    state = {
        blogTable: [],
        blogPostModal: false,
        newPostTitle: '',
        newPostBody: '',
        newPostVideo: '',
        newBlogButton: false,
        editPostId: ''
    };

    componentDidMount() {
        window.scrollTo(0, 0);

        this.getAllPosts();
    };

    componentWillUnmount() {
        this.source.cancel();
    }

    getAllPosts = () => {
        axios.get(
            '/getBlogs',
            {
                cancelToken: this.source.token
            })
            .then((res) => {
                const sortedData = _.orderBy(res.data, ['createdAt'], ['desc'])
                this.setState({ blogTable: sortedData});
            })
            .catch(err => console.log('(GET) Error tyring to fetch blog posts: ', err));
    };

    createNewPost = () =>{
        if(this.state.newPostTitle === null || this.state.newPostTitle === '') {
            this.setState({titleError: true});
        } else if(this.state.newPostBody === null || this.state.newPostBody === '') {
            this.setState({bodyError: true, titleError: false});
        } else {
            this.setState({newBlogButton: true});
            const payload = {
                title: this.state.newPostTitle,
                body: this.state.newPostBody,
                videoEmbed: this.state.newPostVideo
            }

            axios.post(
                '/newBlog',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.getAllPosts();
                    this.setState({
                        blogPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false
                    });
                })
                .catch(err => console.log('(GET) Error tyring to fetch blog posts: ', err));
        }
    };

    editPost = () =>{
        if(this.state.newPostTitle === null || this.state.newPostTitle === '') {
            this.setState({titleError: true});
        } else if(this.state.newPostBody === null || this.state.newPostBody === '') {
            this.setState({bodyError: true, titleError: false});
        } else {
            this.setState({newBlogButton: true});
            const payload = {
                id: this.state.editPostId,
                title: this.state.newPostTitle,
                body: this.state.newPostBody,
                videoEmbed: this.state.newPostVideo
            }

            axios.post(
                '/editBlog',
                payload,
                {
                    cancelToken: this.source.token
                })
                .then((res) => {
                    this.getAllPosts();
                    this.setState({
                        editPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false,
                        editPostId: ''
                    });
                })
                .catch(err => console.log('(GET) Error tyring to fetch blog posts: ', err));
        }
    };

    render () {
        return (
            <div>
                <div className={css.Blog__Main}>
                    <h2 className='text-primary'>Announcements & Stories</h2>
                    {
                        this.props.user.role === 'office' ?
                        <div className="col-5 col-sm-6 col-lg-9 pb-3">
                            <button className="btn btn-primary" type="button" onClick={() => this.setState({blogPostModal:true})}>New Post</button>
                        </div>
                        :
                        ''
                    }
                    <div class={css.Blog__Line}></div>

                    {this.state.blogTable.map(blog => 
                        <div>
                            <h3 className='text-black'>{blog.title}</h3>
                            <p>{moment(blog.createdAt).format('MMM D, YYYY')}</p>
                            {/* <p className={css.Blog__Body}>{blog.body}</p> */}
                            <p className={css.Blog__Body} dangerouslySetInnerHTML={{__html: blog.body}}></p>
                            {
                                blog.videoEmbed ? 
                                <div className={css.Blog__VidContainer}>
                                    <iframe
                                        className={css.Blog__Responsive}
                                        src={blog.videoEmbed}
                                        title="YouTube video player" 
                                        frameborder="0" 
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; fullscreen"
                                        loading="lazy"
                                        allowfullscreen
                                    ></iframe>
                                </div>
                                :
                                <div></div>
                            }
                            {
                                this.props.user.role === 'office' ?
                                <div className="col-5 col-sm-6 col-lg-9 py-2">
                                    <button className="btn btn-primary" type="button" onClick={() => this.setState({
                                        editPostModal:true,
                                        newPostTitle:blog.title,
                                        newPostBody:blog.body,
                                        newPostVideo:blog.videoEmbed,
                                        editPostId:blog.id
                                    })}>Edit</button>
                                </div>
                                :
                                ''
                            }
                            <div class={css.Blog__Line}></div>
                        </div>
                    )}
                </div>

                {/* ---------- Create Blog Post Modal: ---------- */}
                <Modal
                    isOpen={this.state.blogPostModal}
                    onRequestClose={() => this.setState({
                        blogPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div>
                        <div className="d-flex justify-content-between">
                            <div></div>
                            <h2 className='text-primary'>New Blog</h2>
                            <span className="mx-2 cursor-pointer">
                                <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({blogPostModal: false})} />
                            </span>
                        </div>
                        <div className="mt-3">
                            <label className='text-white'>Blog Title</label>
                            <input className={css.Blog__Input} onChange={(event) => this.setState({newPostTitle: event.target.value})} />
                        </div>
                        {
                            this.state.titleError ? 
                            <div className={css.Blog__Error}>
                                <p className='text-danger'>Please Fill Out Title</p>
                            </div>
                            :
                            ''
                        }
                        <div className="mt-3">
                            <label className='text-white'>Blog Body</label>
                            <textarea className={css.Blog__Input} value={this.state.postNotes} onChange={(event) => this.setState({newPostBody: event.target.value})} />
                        </div>
                        {
                            this.state.bodyError ? 
                            <div className={css.Blog__Error}>
                                <p className='text-danger'>Please Fill Out Body</p>
                            </div>
                            :
                            ''
                        }
                        <div className="mt-3 pb-3">
                            <label className='text-white'>Embedded Video Link (Optional)</label>
                            <input className={css.Blog__Input} onChange={(event) => this.setState({newPostVideo: event.target.value})} />
                        </div>
                    </div>
                    <div className='text-center'>
                    <button className="btn btn-primary" disabled={this.state.newBlogButton} onClick={this.createNewPost}>Submit</button>&nbsp;
                    <button className="btn btn-primary" onClick={() => this.setState({
                        blogPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false
                        })}>Close</button>
                    </div>
                </Modal>

                {/* ---------- Edit Blog Post Modal: ---------- */}
                <Modal
                    isOpen={this.state.editPostModal}
                    onRequestClose={() => this.setState({
                        editPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false
                    })}
                    className="ReactModal"
                    overlayClassName="ReactModal__Overlay"
                    style={{
                        overlay: {
                            backgroundColor: 'rgba(255, 255, 255, 0.75)'
                        },
                        content: {
                            background: 'rgba(53, 53, 53)',
                        }
                    }}
                >
                    <div>
                        <div className="d-flex justify-content-between">
                            <div></div>
                            <h2 className='text-primary'>Edit Blog</h2>
                            <span className="mx-2 cursor-pointer">
                                <FontAwesomeIcon icon={faTimes} onClick={() => this.setState({editPostModal: false})} />
                            </span>
                        </div>
                        <div className="mt-3">
                            <label className='text-white'>Blog Title</label>
                            <input className={css.Blog__Input} value={this.state.newPostTitle} onChange={(event) => this.setState({newPostTitle: event.target.value})} />
                        </div>
                        {
                            this.state.titleError ? 
                            <div className={css.Blog__Error}>
                                <p className='text-danger'>Please Fill Out Title</p>
                            </div>
                            :
                            ''
                        }
                        <div className="mt-3">
                            <label className='text-white'>Blog Body</label>
                            <textarea className={css.Blog__Input} value={this.state.newPostBody} onChange={(event) => this.setState({newPostBody: event.target.value})} />
                        </div>
                        {
                            this.state.bodyError ? 
                            <div className={css.Blog__Error}>
                                <p className='text-danger'>Please Fill Out Body</p>
                            </div>
                            :
                            ''
                        }
                        <div className="mt-3 pb-3">
                            <label className='text-white'>Embedded Video Link (Optional)</label>
                            <input className={css.Blog__Input} value={this.state.newPostVideo} onChange={(event) => this.setState({newPostVideo: event.target.value})} />
                        </div>
                    </div>
                    <div className='text-center'>
                    <button className="btn btn-primary" disabled={this.state.newBlogButton} onClick={this.editPost}>Edit Post</button>&nbsp;
                    <button className="btn btn-primary" onClick={() => this.setState({
                        editPostModal: false,
                        newPostTitle: '',
                        newPostBody: '',
                        newPostVideo: '',
                        newBlogButton: false,
                        bodyError: false,
                        titleError: false
                        })}>Close</button>
                    </div>
                </Modal>

            </div>
        )
    };
};

// ---------- Redux mapping: ----------
const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(Blog);